export function createDevBlock() {
  let block = document.getElementById('devBlock')
  if (!block) {
    block = document.createElement('div')
    block.id = 'devBlock'
    block.setAttribute(
      'style',
      `
      position: absolute;
      width: 400px;
      height: 400px;
      z-index: 9999999999;
      background: white;
      overflow: scroll;
      `
    )
    document.body.appendChild(block)
  }
  block.innerHTML = `
    <div 
    id="wrapDevBlock" 
    style="
    position: relative;
    width: 100%;
    height: 100%;
    "
    ></div>
    `
}

let scrollTimer = null
export function putPointToBlock(txt, x, y, coords, r = '5px') {
  let n = document.createElement('div')
  n.setAttribute(
    'style',
    `
    position: absolute;
    top: ${y}px;
    left: ${x}px;
    width: ${r}; height: ${r};
    background: red;
    `
  )
  n.innerHTML = `${txt}<small style="font-size: 9px;">${+coords.lat.toFixed(
    4
  )},${+coords.lng.toFixed(4)}</small>`
  let block = document.getElementById('wrapDevBlock')
  block.appendChild(n)

  if (scrollTimer) {
    clearTimeout(scrollTimer)
  }
  scrollTimer = setTimeout(function () {
    n.scrollIntoView()
  }, 0)
}
